export const CHECKOUT_URL = 'https://fertilidad-en.impultienda.ar/checkout/'

export const PRODUCT_IMAGE =
  'https://cdn.magicpatterns.com/uploads/hJzbnUryahfTr6ZA9L8Kws/FERTILIDAD-EN.png'

export const AUTHOR_IMAGE =
  'https://cdn.magicpatterns.com/uploads/mEtySoNXk1AaZQyFNEgj9X/Dra_Karito_real.png'

export const stats = [
  { value: '+300', label: 'clinical pages' },
  { value: '+1,000', label: 'healthcare professionals already using it' },
  { value: '+1,200', label: 'hours of research saved per year' },
  { value: '98%', label: 'feel more confident when making decisions' },
]

export const beforeItems = [
  'You spend hours reviewing extensive guidelines just to find one answer.',
  'You hesitate when interpreting a complex semen analysis.',
  'You feel uncertain when considering hCG, SERMs, or managing patients with a history of anabolic steroid use.',
  'You order tests without a clearly defined sequence or at the wrong stage of the evaluation.',
  'Every consultation depends on what you happen to remember at that moment.',
  'Your patients sense uncertainty and seek a second opinion.',
]

export const afterItems = [
  'Find the appropriate clinical approach in minutes through an organized clinical pathway.',
  'Quickly understand what the findings mean and what the next step should be.',
  'Use clear, evidence-based protocols for different clinical scenarios.',
  'Know what to order, when to order it, and how to interpret each result.',
  'Follow a clinical algorithm that reduces uncertainty at every stage.',
  'Give your patients a clear plan and build greater confidence in your professional judgment.',
]

export const painPoints = [
  {
    emoji: '😰',
    text: 'You receive a patient with an abnormal semen analysis and, even though you know the theory, you are not completely sure what the next clinical decision should be.',
  },
  {
    emoji: '⏱️',
    text: 'You spend too much time searching for the appropriate use of hCG, Clomiphene, or SERMs across different sources before feeling confident enough to prescribe.',
  },
  {
    emoji: '🤔',
    text: 'It is not always easy to decide when to begin treatment, when to request additional testing, or when to refer for surgery or assisted reproductive technology.',
  },
  {
    emoji: '📉',
    text: 'You feel you could provide much more value during consultations if you had a clear method guiding every clinical decision.',
  },
  {
    emoji: '😓',
    text: 'At the end of the day, you are still thinking about complex cases because you are not completely certain you chose the best strategy for your patient.',
  },
  {
    emoji: '💻',
    text: 'You keep studying scattered information across papers, consensus statements, and guidelines when you could have everything organized in one decision-making system.',
  },
]

export const volumes = [
  {
    roman: 'VOLUME I',
    title: 'The First Decision',
    hook: 'Discover the true cause of the problem before choosing the wrong treatment.',
    body: 'Learn how to perform a strategic clinical evaluation from the very first patient encounter through targeted history-taking and a physical examination focused on the most important clinical signals for an accurate diagnosis.',
  },
  {
    roman: 'VOLUME II',
    title: 'Decoding the Fertility Code',
    hook: 'Interpret the semen analysis like a specialist and discover what the results really mean.',
    body: 'Analyze semen analysis according to WHO 6th Edition criteria, understand the clinical relevance of sperm DNA fragmentation, and transform a complex laboratory report into clear clinical decisions.',
  },
  {
    roman: 'VOLUME III',
    title: 'The Map of Hidden Causes',
    hook: 'Identify the hormonal and genetic origin before starting treatment.',
    body: 'Discover when to request hormonal testing, karyotyping, and Y-chromosome microdeletion testing, and learn how to correctly interpret the hypothalamic-pituitary-testis axis.',
  },
  {
    roman: 'VOLUME IV',
    title: 'The Protocol to Restore Fertility',
    hook: 'Master evidence-based therapeutic strategies designed to restore reproductive function.',
    body: 'Learn when Clomiphene, hCG, FSH, and other therapeutic options may be considered, including specific strategies for patients with a history of testosterone or anabolic steroid use.',
  },
  {
    roman: 'VOLUME V',
    title: 'The Factors That Also Determine the Outcome',
    hook: 'Discover which interventions may actually improve fertility — and which may only waste time and money.',
    body: 'Learn when a varicocele may require surgical evaluation, which supplements have scientific support, and how to optimize modifiable factors that can affect sperm quality.',
  },
  {
    roman: 'VOLUME VI',
    title: 'The Route Toward Pregnancy',
    hook: 'Integrate the entire clinical process and make the right decision at every stage.',
    body: 'Use visual algorithms and clinical cases to determine when to continue treatment, when to refer for assisted reproductive technology, and how to guide the patient toward the next step.',
  },
]

export const deliverables = [
  {
    emoji: '📘',
    title: 'The Complete Clinical Route',
    text: 'All 6 volumes organized into a logical pathway that guides you from the initial evaluation through treatment, follow-up, or referral.',
  },
  {
    emoji: '📋',
    title: 'Ready-to-Use Clinical Protocols',
    text: 'Practical hCG, SERM, and FSH strategies to help you understand when each option may be appropriate and how to monitor the patient safely.',
  },
  {
    emoji: '🔬',
    title: 'Clinical Interpretation Guides',
    text: 'Understand which tests to request, when to request them, and how to interpret the results without overlooking clinically important information.',
  },
  {
    emoji: '🗺️',
    title: 'Clinical Decision Algorithms',
    text: 'Visual diagrams that show you the next step in different clinical scenarios, reducing uncertainty and accelerating decision-making.',
  },
  {
    emoji: '📚',
    title: 'Clinical Cases',
    text: 'Understand how complex situations can be approached using the same structured reasoning used in reproductive medicine.',
  },
]

export const bonuses = [
  {
    tag: 'BONUS #1',
    title: 'Diagnosis in 60 Seconds™',
    hook: 'Interpret semen analysis with confidence in less than one minute.',
    body: 'Forget about searching through endless WHO reference tables. With this visual traffic-light system, you can quickly identify whether key semen parameters are within the reference range or require further clinical evaluation.',
    value: 'USD 19',
    image:
      'https://cdn.magicpatterns.com/uploads/fBqMm6vmJpo24bUMDsoGjo/BONUS_1_FERTILIDAD-EN.png',
    alt: 'Bonus 1: Diagnosis in 60 Seconds — box, tablet, phone and quick-reference cards for the semen analysis traffic-light system',
  },
  {
    tag: 'BONUS #2',
    title: 'Fertility Rescue Protocol™',
    hook: 'A step-by-step strategy for patients who have used testosterone or anabolic steroids.',
    body: 'Learn how fertility recovery may be approached using structured hCG and SERM strategies supported by available evidence. Understand how to evaluate the patient, monitor the response, and avoid common clinical mistakes.',
    value: 'USD 37',
    image:
      'https://cdn.magicpatterns.com/uploads/mbJsecFaj5ELK42DNrVM3w/BONUS_2_FERTILIDAD-EN.png',
    alt: 'Bonus 2: Fertility Rescue Protocol — box, tablet, phone and hCG and SERM protocol cards',
  },
  {
    tag: 'BONUS #3',
    title: 'Patient Education Kit™',
    hook: 'Save time during consultations and improve treatment adherence.',
    body: 'Visual materials ready to print or share digitally, covering nutrition, lifestyle, testicular heat exposure, environmental factors, and other considerations relevant to male fertility.',
    value: 'USD 27',
    image:
      'https://cdn.magicpatterns.com/uploads/8gyyNNDHhR3d6vRyozvVEg/BONUS_3_FERTILIDAD-EN.png',
    alt: 'Bonus 3: Patient Education Kit — box, tablet, phone and printable visual handouts for patients',
  },
  {
    tag: 'BONUS #4',
    title: 'The Evidence-Based Antioxidant Formula™',
    hook: 'Discover which supplements may provide value — and which may only create false expectations.',
    body: 'Understand the evidence surrounding Zinc, CoQ10, Carnitines, Selenium, and other antioxidants, including when they may be considered and what the available evidence actually supports.',
    value: 'USD 20',
    image:
      'https://cdn.magicpatterns.com/uploads/aLoXJG7DaW7CahA2wdcoiw/BONUS_4_FERTILIDAD-EN.png',
    alt: 'Bonus 4: The Evidence-Based Antioxidant Formula — box, tablet, phone and antioxidant dosing reference cards',
  },
  {
    tag: 'BONUS #5',
    title: 'Master Decision Tree™',
    hook: 'The visual map that summarizes the entire Route on a single page.',
    body: 'From the first consultation to the decision to continue treatment or refer for assisted reproductive technology, this visual guide connects the entire clinical process.',
    value: 'USD 37',
    image:
      'https://cdn.magicpatterns.com/uploads/wWPYCwWxpudtRX1V1EuELm/BONUS_5_FERTILIDAD-EN.png',
    alt: 'Bonus 5: Master Decision Tree — box, tablet, phone and the full one-page clinical decision map',
  },
]

export const testimonials = [
  {
    name: 'Dr. Sophie D.',
    role: 'General Practitioner',
    country: 'United Kingdom 🇬🇧',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/d5c688b7-78ac-4168-ae0e-55abca2dfd31.jpg',
    quote:
      'After years of seeing patients with male infertility, this resource accomplished something no textbook had been able to do: it organized the entire clinical process into a clear and easy-to-follow route. Today I feel much more prepared when I walk into a consultation.',
  },
  {
    name: 'Dr. James M.',
    role: 'Urologist',
    country: 'United States 🇺🇸',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/81f35e3e-2438-45cd-9a32-1ed7c061fe35.jpg',
    quote:
      'The visual system for interpreting semen analysis completely changed the way I work. I can now explain the results more clearly and determine the next step in minutes.',
  },
  {
    name: 'Dr. Charles T.',
    role: 'Endocrinologist',
    country: 'Australia 🇦🇺',
    photo:
      'https://cdn.magicpatterns.com/patterns/generated-images/1f936dfc-a07a-4baa-9293-484540fc5d5c.jpg',
    quote:
      'What I value most is not just the protocols. It is the confidence of knowing what to consider in each scenario. My patients notice that confidence too.',
  },
]

export const faqs = [
  {
    q: 'Is the Male Fertility Route a video course?',
    a: 'No. It is a digital clinical reference system designed to help you find relevant information quickly when you need it. You can study it from beginning to end or use it as a reference tool during your professional practice.',
  },
  {
    q: 'Will I receive access immediately after purchasing?',
    a: 'Yes. After completing your purchase, you will receive instructions to access the digital materials. You can begin using the resources immediately.',
  },
  {
    q: 'Is it only for urologists?',
    a: 'No. The Route was designed for healthcare professionals who evaluate or manage patients with male infertility, including physicians working in general practice, urology, endocrinology, reproductive medicine, and related areas.',
  },
  {
    q: 'Is the content based on scientific evidence?',
    a: 'The material is structured around established scientific literature, clinical guidelines, consensus documents, and internationally recognized references relevant to male infertility. Where evidence is limited or recommendations vary, the material makes those limitations clear.',
  },
  {
    q: 'Do I need previous experience in andrology?',
    a: 'Not necessarily. The Route is organized progressively, beginning with clinical evaluation and diagnosis and moving through interpretation, treatment, monitoring, and referral. However, it is an educational resource for healthcare professionals and does not replace specialized medical training or clinical judgment.',
  },
  {
    q: 'How long will I have access?',
    a: 'Your purchase includes lifetime access to the digital material, according to the access terms provided at checkout.',
  },
  {
    q: 'What happens if the material doesn’t meet my expectations?',
    a: 'You have a 7-day guarantee. If you decide that the material is not right for you, contact us within the applicable guarantee period and request your refund according to the stated refund policy.',
  },
  {
    q: 'Does this material replace a medical specialty or official clinical guidelines?',
    a: 'No. The Male Fertility Route is an educational and clinical reference resource. It does not replace specialist training, professional judgment, institutional protocols, medication labeling, or current official guidelines.',
  },
]

export const purchaseNotifications = [
  { name: 'Dr. Emily Carter', place: 'Manchester, United Kingdom' },
  { name: 'Dr. Michael Brennan', place: 'Chicago, United States' },
  { name: 'Dr. Olivia Bennett', place: 'Toronto, Canada' },
  { name: 'Dr. Daniel O’Connor', place: 'Dublin, Ireland' },
  { name: 'Dr. Priya Sharma', place: 'Melbourne, Australia' },
  { name: 'Dr. James Whitfield', place: 'Leeds, United Kingdom' },
  { name: 'Dr. Sarah Thompson', place: 'Auckland, New Zealand' },
  { name: 'Dr. Robert Nolan', place: 'Houston, United States' },
  { name: 'Dr. Aisha Khan', place: 'Birmingham, United Kingdom' },
  { name: 'Dr. Andrew Miller', place: 'Vancouver, Canada' },
]
